import { render, staticRenderFns } from "./YouthStudy.vue?vue&type=template&id=2b424976&scoped=true&"
import script from "./YouthStudy.vue?vue&type=script&lang=js&"
export * from "./YouthStudy.vue?vue&type=script&lang=js&"
import style0 from "./YouthStudy.vue?vue&type=style&index=0&id=2b424976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b424976",
  null
  
)

export default component.exports